import React, { useState } from 'react';
import { X, ArrowRight } from 'lucide-react';

const WorkGallery = () => {
  const [selectedImage, setSelectedImage] = useState(null);
  const facebookPageLink = 'https://www.facebook.com/profile.php?id=61581426567365';

  const workImages = [
    { id: 1, src: '/assets/images/work/work-1.jpeg', alt: 'Car exterior detailing' },
    { id: 2, src: '/assets/images/work/work-2.jpeg', alt: 'Interior deep clean' },
    { id: 3, src: '/assets/images/work/work-3.jpeg', alt: 'Wheel cleaning' },
    { id: 4, src: '/assets/images/work/work-4.jpeg', alt: 'Engine bay clean' },
    { id: 5, src: '/assets/images/work/work-5.jpeg', alt: 'Full valet service' },
    { id: 6, src: '/assets/images/work/work-6.jpeg', alt: 'Paint protection' },
    { id: 7, src: '/assets/images/work/work-7.jpeg', alt: 'Steam cleaning' },
    { id: 8, src: '/assets/images/work/work-8.jpeg', alt: 'Before and after valeting' },
  ];

  return (
    <section className="section section-dark">
      <div className="container">
        <div className="section-header">
          <div className="eyebrow">Our Work</div>
          <h2>See The Difference We Make</h2>
          <p>
            Professional results that speak for themselves. Browse our gallery of
            completed jobs.
          </p>
        </div>

        <div className="gallery-grid">
          {workImages.map((image) => (
            <div
              key={image.id}
              className="gallery-item"
              onClick={() => setSelectedImage(image)}
              role="button"
              tabIndex={0}
              onKeyDown={(e) => e.key === 'Enter' && setSelectedImage(image)}
              aria-label={`View ${image.alt}`}
            >
              <img
                src={image.src}
                alt={image.alt}
                loading="lazy"
                onError={(e) => {
                  e.target.parentElement.style.display = 'none';
                }}
              />
            </div>
          ))}
        </div>

        <div className="gallery-cta">
          <button
            onClick={() => window.open(facebookPageLink, '_blank')}
            className="see-more-btn"
          >
            See More On Facebook
            <ArrowRight size={18} />
          </button>
        </div>

        {selectedImage && (
          <div
            className="gallery-lightbox"
            onClick={() => setSelectedImage(null)}
            role="dialog"
            aria-modal="true"
            aria-label="Image preview"
          >
            <button
              onClick={() => setSelectedImage(null)}
              className="gallery-lightbox-close"
              aria-label="Close"
            >
              <X size={24} />
            </button>
            <img
              src={selectedImage.src}
              alt={selectedImage.alt}
              onClick={(e) => e.stopPropagation()}
            />
          </div>
        )}
      </div>
    </section>
  );
};

export default WorkGallery;